import React from 'react'
import { useApiErrors } from 'core/services/suggPro/useApiErrors'
import { Address, Establishment, useEstablishmentUpdate } from '@sugg-gestion/ubidreams-react-suggpro'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { LocationFormState } from 'components/forms/establishment/locationForm'
import EstablishmentLocationDialogView from 'components/views/establishment/dialogs/establishmentLocationDialogView'

interface Props {
    open: boolean
    onClose: () => void
    establishment: Establishment
}

const EstablishmentEditLocationDialog: React.FC<Props> = ({ establishment, open, onClose }) => {
    const { enqueueSnackbar } = useSnackbar()
    const { t } = useTranslation()

    const { displayError } = useApiErrors()
    const { updateEstablishment, inProgress } = useEstablishmentUpdate()

    const handleUpdateLocation = (values: LocationFormState) => {
        const completeAddress: Address = {
            street_1: values.address_street_1 ?? null,
            street_2: values.address_street_2 ?? null,
            zip_code: values.address_zip_code ?? null,
            city: values.address_city ?? null,
            country: values.address_country ?? null,
        }
        updateEstablishment({
            id: establishment.id,
            establishment: {
                location: values.position,
                completeAddress,
            },
        })
            .then(() => {
                enqueueSnackbar(t('views.establishment.location.success'), {
                    variant: 'success',
                })
                onClose()
            })
            .catch((error) => displayError(error))
    }

    return (
        <EstablishmentLocationDialogView
            open={open}
            onClose={onClose}
            onSubmit={handleUpdateLocation}
            inProgress={inProgress}
            initialValues={{
                address_street_1: establishment.completeAddress.street_1 ?? '',
                address_street_2: establishment.completeAddress.street_2 ?? '',
                address_zip_code: establishment?.completeAddress.zip_code ?? '',
                address_city: establishment?.completeAddress.city ?? '',
                address_country: establishment?.completeAddress.country ?? 'FR',
                position: establishment?.location,
            }}
        />
    )
}

export default EstablishmentEditLocationDialog
